import { Component, OnInit } from '@angular/core';
import {Election} from '../../../api/models/election';
import {CompanyService} from '../../../shared/services/company.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../../shared/services/alert.service';
import {empty} from '../../../functions';
import {ElectionService} from '../../../shared/services/election.service';

@Component({
    selector: 'app-modal-company-election-signup',
    templateUrl: './modal-company-election-signup.component.html',
    styleUrls: ['./modal-company-election-signup.component.scss'],
    standalone: false
})
export class ModalCompanyElectionSignupComponent implements OnInit {

  public data:any;

  public election = {} as Election;

  public companyId:string = '';
  public areaId: string|null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private companyService: CompanyService,
    private alert: AlertService,
    public electionService: ElectionService
  ) { }

  ngOnInit(): void
  {

      this.election = this.data.election;
      this.companyId = this.data.companyId;
  }


  signUp()
  {

    if (!this.companyId || !this.election.id || !this.areaId) {
      return;
    }

    this.companyService.createCompanyAwvlElectionProfile(this.companyId, this.election.id, this.areaId).subscribe( (response: any) => {

      this.alert.success('You successfully signed up for election');

      this.activeModal.close(true);

    });

  }

  setAreaId(areaId:string) {

    this.areaId = areaId;
  }

  valid(): boolean
  {
    return (!empty(this.election.id) && !empty(this.companyId) && !empty(this.areaId));
  }
}
